import { NavigationExtras, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Component, OnInit } from '@angular/core';
import { catchError, finalize, of } from 'rxjs';

import { PropertyListingStateService } from '../../../../app/shared/services/sell-your-property/property-listing-state.service';
import { NotificationService } from '../../../../app/shared/services/notification-service/notification.service';
import { LookupService, UserManagementService } from '../../../../app/services/property-matrixV2/services';
import { PropertyListingTypeDto, UserDto } from '../../../../app/services/property-matrixV2/models';
import { GlobalMethods } from '../../../../app/common/global-methods';

@Component({
  selector: 'app-choose-listing',
  templateUrl: './choose-listing.component.html',
  styleUrls: ['./choose-listing.component.scss', '../../../../css/styles.scss']
})

export class ChooseListingComponent implements OnInit {

  loading: boolean = false;
  isloggedIn: boolean = false;
  propertyListTypeList: PropertyListingTypeDto[] = [];
  leafletRoute: string = "/sell-your-property/steps";
  planningReportRoute: string = "/sell-your-property/overview";
  sellerType: string = "broker-agent";
  propertyListTypeFilteredList: PropertyListingTypeDto[] = [];

  constructor(
    private _router: Router,
    private _notificationService: NotificationService,
    private _lookupService: LookupService,
    private keycloakService: KeycloakService,
    private _userManagementService: UserManagementService,
    private propertyListingStateService: PropertyListingStateService,
  ) { }

  ngOnInit(): void {
    this.keycloakService.isLoggedIn().then((loggedIn: boolean) => {
      this.isloggedIn = loggedIn;
    });
    this.getPropertyListingTypes();
    GlobalMethods.scrollToTop();
  }

  public onProceed(route: string, sellerType: string, listingType: string): void {
    if (this.isloggedIn) {
      this.checkPropertyListingTypeItem(listingType);
      this.checkIfLoggedInUserIsAgent(route, sellerType, listingType);
    } else {
      this._notificationService.showWarningMessage("Warning", "Please login to create listing.");
    }
  }

  public proceedClick(propertyListingType: PropertyListingTypeDto, listingType: string): void {
    if (this.isloggedIn) {
      this.checkPropertyListingTypeItem(propertyListingType.description);
      switch (propertyListingType.description) {
        case 'Leaflet': {
          this.checkIfLoggedInUserIsAgent(this.leafletRoute, this.sellerType, listingType);
        }
        case 'Planning Report': {
          this.checkIfLoggedInUserIsAgent(this.planningReportRoute, this.sellerType, listingType);
        }
        default: {
          this._notificationService.showWarningMessage("Warning", "Please choose a property listing type.");
        }
      }
    } else {
      this._notificationService.showWarningMessage("Warning", "Please login to create listing.");
    }
  }

  private checkIfLoggedInUserIsAgent(route: string, sellerType: string, listingType: string): void {
    try {
      this.loading = true;
      this._userManagementService.apiV1UserManagementGetCurrentUserLoggedInUserGet({})
        .pipe(
          catchError((err) =>
            of(this._notificationService.showErrorMessage("Error", "Error getting the filtered advert data."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: UserDto | void) => {
          if (result && result.userRoles) {
            const containsRoles = result.userRoles.some(r => (r.roleName === 'Network Agent' && result.endorsed) || (r.roleName === 'Principal Agent' && result.endorsed) || (r.roleName === 'Planner Portal Administrator'));
            if (containsRoles == false) {
              if (result.endorsed == false) {
                this._notificationService.showWarningMessage("Warning", "You are not endorsed as an agent. Please contact your administrator.");
              }
              else {
                this._notificationService.showWarningMessage("Warning", "You are not an agent. Please contact your administrator.");
              }
            }
            else {
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  sellerType: sellerType,
                  listingType: listingType,
                }
              };
              this._router.navigate([route], navigationExtras);
            }
          } else {
            this._notificationService.showErrorMessage('Error', 'Could not load current logged in users to check the role.');
          }
        });
    }
    catch (e) {
      this._notificationService.showErrorMessage('Error', 'Could not load current logged in users to check the role.');
    }
  }

  private getPropertyListingTypes(): void {
    try {
      this.loading = true;
      this._lookupService.apiV1LookupGetPropertyListingTypesGet({})
        .pipe(
          catchError((err) =>
            of(this._notificationService.showErrorMessage("Error", "Error getting the Property Listing Types data."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: PropertyListingTypeDto[] | void) => {
          if (result && result.length > 0) {
            this.propertyListTypeList = result;
            this.propertyListTypeFilteredList = result.filter(p => p.description != "None");
          } else {
            this._notificationService.showErrorMessage('Error', 'There are none  Property listing Types.');
          }
        });
    }
    catch (e) {
      this._notificationService.showErrorMessage('Error', 'Could not load Property listing Types.');
    }
  }

  private checkPropertyListingTypeItem(listingType: string | null | undefined): void {
    try {
      for (let index = 0; index < this.propertyListTypeList.length; index++) {
        const element = this.propertyListTypeList[index];
        if (element.description.toUpperCase() == listingType.toUpperCase()) {
          this.propertyListingStateService.updatePropertyListingType(element);
        }
      }
    }
    catch (e) {
      this._notificationService.showErrorMessage('Error', 'Could not load Property listing Types.');
    }

  }
}
